/**
 * Distribution du build : public (stores, web public) ou interne (dev, QA).
 *
 * Regle de securite, dans ce sens uniquement : un bundle de production est
 * TOUJOURS public, quelle que soit la valeur de REACT_APP_DISTRIBUTION. Une
 * variable absente, mal orthographiee ou oubliee dans une CI ne peut donc
 * jamais rouvrir un parcours interne dans un build store.
 *
 * Ce que "interne" autorise, et rien d'autre :
 * - les parcours beta / codes d'invitation dans l'UI ;
 * - le mock de paiement quand RevenueCat n'est pas configure.
 *
 * Hors production (dev local, tests), le build est interne par defaut ;
 * REACT_APP_DISTRIBUTION=public permet de reproduire le comportement store.
 */

import { isNative } from '../utils/platformUtils';

export function isInternalBuild() {
  if (process.env.NODE_ENV === 'production') return false;
  const value = (process.env.REACT_APP_DISTRIBUTION || '').trim().toLowerCase();
  return value !== 'public';
}

export function isPublicBuild() {
  return !isInternalBuild();
}

/**
 * Saisie d'un code d'invitation.
 *
 * Interdite dans les builds natifs publics uniquement : deverrouiller du
 * contenu payant par un code maison contourne l'IAP (App Store 3.1.1, regle
 * equivalente chez Google). Sur le web, aucun store ne s'interpose et les codes
 * restent le moyen d'offrir l'app ; l'entitlement obtenu la suit ensuite le
 * compte jusque sur mobile.
 *
 * A ne pas confondre avec le mock de paiement, interdit partout en production,
 * web compris : l'un releve de la politique des stores, l'autre de la
 * protection des revenus.
 */
export function canRedeemInviteCode() {
  return isInternalBuild() || !isNative();
}
